export default "__VITE_ASSET__CZs2sgmi__"